// extracted by mini-css-extract-plugin
export default {"draggable":"SortableList_draggable__xA6j7","handle":"SortableList_handle__JVzvK","item":"SortableList_item__aR5Ql","placeholder":"SortableList_placeholder__4ju2y"};